// TODO: detect if menu items are slotted and add class to ul

import { Component, h } from '@stencil/core';

@Component({
  tag: 'cwru-form-input-button',
  styleUrl: 'form.css',
  shadow: false,
})
export class FormInputButton {
  render() {
    return (
      <div class="form_question_buttons">
        <slot />
      </div>
    );
  }
}
